import { Building2, CalendarClock, CheckSquare, Clock, Flag, Paperclip, User } from "lucide-react";
import { NeuSelect } from "../../components/neu/Neu";
import { DateInput } from "../../components/neu/DateInput";

const PRIORITIES = ["low", "medium", "high", "urgent"];

const Toggle = ({ icon: Icon, label, value, onClick, testid }) => (
  <button type="button" data-testid={testid} onClick={onClick}
    className={`flex items-center gap-2 rounded-2xl px-4 py-3 text-sm font-bold shadow-neu-sm transition-colors sm:text-xs ${value ? "text-primary" : "text-muted-foreground"}`}>
    <span className={`grid h-6 w-6 place-items-center rounded-lg ${value ? "bg-primary text-primary-foreground" : "shadow-neu-in"}`}><Icon className="h-3.5 w-3.5" /></span>
    {label}
  </button>
);

const L = ({ icon: Icon, label, tone, children }) => (
  <label className="grid min-w-0 gap-1.5 text-sm font-bold sm:text-xs">
    <span className={`flex items-center gap-1.5 ${tone}`}><Icon className="h-4 w-4" /> {label}</span>
    {children}
  </label>
);

export const TaskFormMeta = ({ form, set, setForm, branches, employees, t }) => {
  const emp = form.branch_id ? employees.filter((e) => !e.branch_id || e.branch_id === form.branch_id) : employees;
  const toggle = (key) => () => setForm((f) => ({ ...f, [key]: !f[key] }));
  return (
    <>
      <L icon={Building2} label={t("tasks.fields.branch")} tone="text-emerald-600">
        <NeuSelect data-testid="task-branch" value={form.branch_id} onChange={set("branch_id")}>
          <option value="">{t("tasks.filters.all")}</option>
          {branches.map((b) => <option key={b.id} value={b.id}>{b.name}</option>)}
        </NeuSelect>
      </L>
      <L icon={User} label={t("tasks.fields.assignee")} tone="text-sky-600">
        <NeuSelect data-testid="task-assignee" value={form.assignee_id} onChange={set("assignee_id")}>
          <option value="">—</option>
          {emp.map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}
        </NeuSelect>
      </L>
      <L icon={CalendarClock} label={t("tasks.fields.start")} tone="text-teal-600">
        <DateInput testId="task-start" value={form.start_date} onChange={(v) => setForm((f) => ({ ...f, start_date: v }))} />
      </L>
      <L icon={CalendarClock} label={t("tasks.fields.due")} tone="text-rose-600">
        <DateInput testId="task-due" value={form.due_date} onChange={(v) => setForm((f) => ({ ...f, due_date: v }))} />
      </L>
      <L icon={Clock} label={t("tasks.fields.dueTime")} tone="text-indigo-600">
        <input type="time" data-testid="task-due-time" value={form.due_time || ""} onChange={set("due_time")} dir="ltr"
          className="h-12 w-full min-w-0 appearance-none rounded-2xl bg-background px-4 text-base shadow-neu-in focus:outline-none focus:ring-2 focus:ring-ring sm:text-sm [&::-webkit-date-and-time-value]:text-left [&::-webkit-datetime-edit]:p-0" />
      </L>
      <L icon={Flag} label={t("tasks.fields.priority")} tone="text-amber-600">
        <NeuSelect data-testid="task-priority" value={form.priority} onChange={set("priority")}>
          {PRIORITIES.map((p) => <option key={p} value={p}>{t(`tasks.priority.${p}`)}</option>)}
        </NeuSelect>
      </L>
      <div className="flex flex-wrap gap-2 sm:col-span-2">
        <Toggle icon={CheckSquare} testid="task-requires-approval" label={t("tasks.fields.requiresApproval")} value={form.requires_approval} onClick={toggle("requires_approval")} />
        <Toggle icon={Paperclip} testid="task-requires-attachment" label={t("tasks.fields.requiresAttachment")} value={form.requires_attachment} onClick={toggle("requires_attachment")} />
      </div>
    </>
  );
};
